module.exports = __webpack_public_path__ + "img/sacMobile.79b31a4b.png";